import type { TOC } from '@ember/component/template-only';
import SettingsRecommendationsPriceRange from 'lumen/components/settings/recommendations/price-range';
import type HotelSettingsRecommendationsPriceRangeRoute from 'lumen/routes/hotel/settings/recommendations/price-range';
import type { ModelFrom } from 'lumen/utils/routes';

interface HotelSettingsRecommendationsPriceRangeSignature {
  Args: {
    controller: unknown;
    model: ModelFrom<HotelSettingsRecommendationsPriceRangeRoute>;
  };
}

<template>
  <SettingsRecommendationsPriceRange @model={{@model}} />
</template> satisfies TOC<HotelSettingsRecommendationsPriceRangeSignature>;
